// Light/dark theme. Light is the default and the only value used until the
// user picks dark (white-first law). The choice lives in localStorage and on
// <html data-theme>; storage can be blocked, so every access is guarded.
import { useCallback, useState } from "react";

export type Theme = "light" | "dark";

export const THEME_KEY = "procureai.theme";

export function readTheme(): Theme {
  try {
    const v = localStorage.getItem(THEME_KEY);
    return v === "dark" || v === "light" ? v : "light";
  } catch {
    return "light";
  }
}

export function applyTheme(t: Theme): void {
  const root = document.documentElement;
  root.dataset.theme = t;
  root.style.colorScheme = t;
}

export function setTheme(t: Theme): void {
  applyTheme(t);
  try {
    localStorage.setItem(THEME_KEY, t);
  } catch {
    // storage blocked: the choice still applies for this page view
  }
}

export function useTheme(): [Theme, (t: Theme) => void] {
  const [theme, setState] = useState<Theme>(() => readTheme());
  const set = useCallback((t: Theme) => {
    setTheme(t);
    setState(t);
  }, []);
  return [theme, set];
}
